// import moment from 'moment-ja'
import DateTextPicker from '@/components/common/DateTextPicker/DateTextPicker'

export default {
  name: 'DateSpan',
  props: {
    type: {
      type: String,
      default: 'date'
    },
    date1: {
      type: String,
      default: null
    },
    date2: {
      type: String,
      default: null
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      default: false
    }
  },
  components: {
    DateTextPicker: DateTextPicker
  },
  data: () => ({
    menuDateSpan1: false,
    menuDateSpan2: false
  }),
  computed: {
    modelDate1: {
      get () {
        return this.date1
      },
      set (val) {
        this.$emit('update:date1', val)
      }
    },
    modelDate2: {
      get () {
        return this.date2
      },
      set (val) {
        this.$emit('update:date2', val)
      }
    }
  }
}
